(() => {
  const e = "scroll-trigger--offscreen",
    t = "scroll-trigger--cancel";
  function s(s, r) {
    s.forEach((s, n) => {
      if (s.isIntersecting) {
        const t = s.target;
        t.classList.contains(e) &&
          (t.classList.remove(e),
          t.hasAttribute("data-cascade") &&
            t.setAttribute("style", `--animation-order: ${n};`)),
          r.unobserve(t);
      } else s.target.classList.add(e), s.target.classList.remove(t);
    });
  }
  function r(e = document, t = !1) {
    const r = Array.from(e.getElementsByClassName("scroll-trigger"));
    if (0 === r.length) return;
    if (t)
      return void r.forEach((e) => {
        e.classList.add("scroll-trigger--design-mode");
      });
    const n = new IntersectionObserver(s, { rootMargin: "0px 0px -50px 0px" });
    r.forEach((e) => n.observe(e));
  }
  window.addEventListener("DOMContentLoaded", () => r()),
    Shopify.designMode &&
      (document.addEventListener("shopify:section:load", (e) =>
        r(e.target, !0)
      ),
      document.addEventListener("shopify:section:reorder", () =>
        r(document, !0)
      ));
})();
